import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory, useParams } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';
import { UncontrolledTable } from '~/components';

const NotesIndex = () => {
  const history = useHistory();
  const params = useParams();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${params.patient_id}/notes/add`}
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Note</span>
          </Button>
        }
      >
        Notes
      </PageTitle>

      <UncontrolledTable
        name="patient-notes"
        endpoint={{
                url: 'data/public/patient_note',
                params: {
                  patient_uid: params.patient_id,
                  is_archived: false,
                 },
              }}
        defaultSorted={[{ id: 'createdDate', desc: true }]}
        columns={[
           {
             id: 'note',
             Header: 'Notes',
             accessor: 'attributes.note',
             cellType: 'textarea',
           },
           {
             id: 'createdDate',
             Header: 'Created Date',
             accessor: 'attributes.createdDate',
             cellType: 'date',
           },
           {
            id: 'authorLastName,authorFirstName',
            Header: 'Created By',
            accessor: x => `${x.attributes.authorLastName}, ${x.attributes.authorFirstName}`,
            cellType: 'textarea',
          }]}
        getTrProps={(state, rowInfo) => ({
          style: {
            cursor: 'pointer',
          },
          onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/patients/${params.patient_id}/notes/${rowInfo.original.id}/details`, rowInfo.original)),
        })}
      />

    </>
  );
};

export default NotesIndex;
